import { EventEmitter } from 'events';
import invariant from 'invariant';
import { ActionTypes } from 'search/constants';
import { Dispatcher } from 'search/Dispatcher';

const CHANGE_EVENT = 'change';

let _boundingBoxObject = null;

export const SearchBoundingBoxStore = {
  ...EventEmitter.prototype,
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  get() {
    invariant(
      _boundingBoxObject !== null,
      "Bounding box is not set, can't get()! Bounding box will be available " +
        'once actions informing map bounding box are fired (e.g. MAP_AREA_CHANGED).'
    );
    return _boundingBoxObject;
  },

  getNorth() {
    const bbox = SearchBoundingBoxStore.get();
    return bbox.getNorth();
  },

  getEast() {
    const bbox = SearchBoundingBoxStore.get();
    return bbox.getEast();
  },

  getSouth() {
    const bbox = SearchBoundingBoxStore.get();
    return bbox.getSouth();
  },

  getWest() {
    const bbox = SearchBoundingBoxStore.get();
    return bbox.getWest();
  }
};

SearchBoundingBoxStore.dispatchToken = Dispatcher.register(payload => {
  const action = payload.action;

  switch (action.type) {
    case ActionTypes.MAP_AREA_CHANGED:
    // Fall through
    case ActionTypes.SEARCH_FROM_MAP_AREA:
      _boundingBoxObject = action.boundingBox;
      SearchBoundingBoxStore.emitChange();
      break;
    default:
    // do nothing
  }
});

// Exported for testing purposes only!
export function __setBoundingBoxObject(boundingBox) {
  _boundingBoxObject = boundingBox;
}
